import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useTranslation } from "../translations";
import PremiumBadge from '../components/premium/PremiumBadge';
import { ChcePremiumButton } from '../components/premium/PremiumNotice';
import { API_BASE } from '../config';
import { PanelContainer, Title as CommonTitle, Subtitle as CommonSubtitle, SectionTitle } from '../ui/common';

// Ikony kart. Utrzymane lokalnie (nie w ui/icons.js): ta strona potrzebuje motywów
// (umowa, budynek, cennik, pakiet, import, widget), których we wspólnym zestawie nie ma,
// a dokładanie ich tam byłoby zadaniem innej fali. Wszystkie rysują się `currentColor`,
// więc dziedziczą kolor z CardIcon i nie wymagają osobnego traktowania w trybie ciemnym.
const UserIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const ShieldIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const UsersIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const SettingsIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const MailIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" strokeWidth="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ContractIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 2v6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const BuildingIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="9 22 9 12 15 12 15 22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="9" y1="5" x2="9" y2="9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="15" y1="5" x2="15" y2="9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const PriceTagIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="7" y1="7" x2="7.01" y2="7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const BundleIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 8l-9-5-9 5v8l9 5 9-5V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3 8l9 5 9-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="12" y1="13" x2="12" y2="21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const RulesIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="8" y="2" width="8" height="4" rx="1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 12h6M9 16h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const ImportIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="14 2 14 8 20 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="12" y1="11" x2="12" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <polyline points="9 14 12 17 15 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ExportIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="3" width="20" height="5" rx="1" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
    <path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="10" y1="12" x2="14" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const WidgetIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2"/>
    <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2"/>
    <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2"/>
    <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

// Nagłówek strony to celowo scentralizowany "hero" blok, nie PageHeader z ui/common.js:
// PageHeader jest układem tytuł-po-lewej/akcje-po-prawej, a ta strona nie ma żadnych akcji
// w nagłówku — środkowanie jest tu świadomą decyzją wizualną węzła startowego, nie
// zaniedbaniem. Title/Subtitle są jednak IMPORTOWANE ze wspólnego pliku, nie kopiowane.
const Hero = styled.div`
  text-align: center;
  margin-bottom: var(--sp-8);
`;

// U.14: plakietka planu w nagłówku profilu. Trzy warianty ('superadmin' | 'premium' | 'basic')
// mapowane na tokeny znaczeniowe zamiast kolorów wpisanych wprost — superadmin bierze --info
// (rola specjalna, niebieska rodzina), premium --warning (bursztyn, zgodnie z resztą aplikacji),
// basic zostaje neutralny (text-muted/panel-bg/border). Oba tokeny mają osobne wartości w trybie
// ciemnym zdefiniowane w index.css, więc — inaczej niż poprzednio — nic tu nie trzeba nadpisywać
// pod `[data-theme='dark']`.
const PlanBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: var(--sp-1);
  margin-top: var(--sp-4);
  padding: var(--sp-1) var(--sp-4);
  border-radius: var(--r-pill);
  font-size: var(--fs-sm);
  font-weight: 700;
  letter-spacing: 0.01em;
  border: 1px solid;

  ${(p) => p.variant === 'superadmin' && `
    color: var(--info);
    background: var(--info-bg);
    border-color: var(--info-border);
  `}
  ${(p) => p.variant === 'premium' && `
    color: var(--warning);
    background: var(--warning-bg);
    border-color: var(--warning-border);
  `}
  ${(p) => p.variant === 'basic' && `
    color: var(--text-muted);
    background: var(--panel-bg);
    border-color: var(--input-border);
  `}
`;

// Jedna grupa kart = jeden nagłówek sekcji. Zastępuje kolor jako sygnał kategorii (patrz Grid/
// ProfileCard niżej) — grupa i tekst niosą teraz to, co wcześniej próbowało nieść 11 gradientów.
const Group = styled.section`
  margin-bottom: var(--sp-8);

  &:last-child {
    margin-bottom: 0;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--sp-6);

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

/**
 * DECYZJA PROJEKTOWA (v2, zastępuje "tęczę kart" z audytu punkt 1): jednolity `--primary`
 * na WSZYSTKICH 11 ikonach naprawiał rozjazd znaczenia (żaden kolor nie kodował kategorii),
 * ale wprowadził inny problem — pełna, nasycona plakietka z białą ikoną na niebieskim
 * kwadracie to dokładnie ten sam wzorzec, który powtarza się na każdym wygenerowanym przez
 * AI dashboardzie. Rozwiązanie: kolor wraca jako sygnał, ale przypisany do GRUPY (4 kolory,
 * nie 11) i w innej stylistyce — miękki podkolorowany kafelek zamiast pełnego wypełnienia,
 * dokładnie ten sam trójkowy wzorzec tło+obrys+tekst, którego PlanBadge wyżej już używa dla
 * plakietki planu. `CARD_TONES` niżej dobrane z palety "górskiej chaty" pasującej do
 * wypożyczalni narciarskiej (stal/lód, drewno/glina, świerk, zmierzchowy fiolet) — świadomie
 * odsunięte od tokenów stanu (`--success/--danger/--warning/--info`), żeby kategoria karty
 * nigdy nie czytała się jako komunikat błędu/ostrzeżenia.
 */
const CARD_TONES = {
  // Konto — stal/lód: chłodny, neutralny szary błękit (celowo inny odcień niż --primary).
  account: {
    fg: '#3d5a76', bg: '#eef2f7', border: '#d7e0ea',
    fgDark: '#9fb8d1', bgDark: 'rgba(96,140,181,0.16)', borderDark: 'rgba(96,140,181,0.34)',
  },
  // Firma i dokumenty — drewno/glina: ciepły rdzawy brąz, kojarzy się z papierem i drewnem.
  company: {
    fg: '#a35a2f', bg: '#fdf1e9', border: '#f3d9c4',
    fgDark: '#e3a679', bgDark: 'rgba(211,124,68,0.16)', borderDark: 'rgba(211,124,68,0.34)',
  },
  // Sprzedaż — świerk: zgaszona zieleń, odsunięta od jaśniejszego --success.
  sales: {
    fg: '#2f7d68', bg: '#eaf6f2', border: '#cdebe1',
    fgDark: '#7fd4bb', bgDark: 'rgba(63,166,140,0.16)', borderDark: 'rgba(63,166,140,0.34)',
  },
  // Integracje — zmierzch: stonowany fiolet, sygnalizuje "techniczne" bez sięgania po niebieski.
  integrations: {
    fg: '#6b4f96', bg: '#f3eefa', border: '#e0d3f0',
    fgDark: '#c3aae8', bgDark: 'rgba(139,105,196,0.16)', borderDark: 'rgba(139,105,196,0.34)',
  },
};

const ProfileCard = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: block;
  background: var(--card-bg);
  border: 1px solid var(--input-border);
  border-radius: var(--r-lg);
  padding: var(--sp-8) var(--sp-6);
  transition: transform var(--dur) var(--ease), box-shadow var(--dur) var(--ease), border-color var(--dur) var(--ease);
  position: relative;

  &:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-lg);
    border-color: var(--primary);
  }
`;

const DisabledCard = styled.div`
  background: var(--panel-bg);
  border: 1px solid var(--input-border);
  border-radius: var(--r-lg);
  padding: var(--sp-8) var(--sp-6);
  opacity: 0.7;
  cursor: not-allowed;
  position: relative;
  color: var(--text-muted);

  &::after {
    /* Kłódka jako maska: kształt z SVG, kolor z currentColor, więc gaśnie razem z resztą
       wyłączonej karty w obu motywach. Prefiks -webkit- nadal potrzebny dla Safari. */
    content: '';
    position: absolute;
    top: var(--sp-4);
    right: var(--sp-4);
    width: 18px;
    height: 18px;
    background-color: currentColor;
    -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='4' y='10' width='16' height='11' rx='2'/%3E%3Cpath d='M8 10V7a4 4 0 0 1 8 0v3'/%3E%3C/svg%3E") center / contain no-repeat;
    mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='4' y='10' width='16' height='11' rx='2'/%3E%3Cpath d='M8 10V7a4 4 0 0 1 8 0v3'/%3E%3C/svg%3E") center / contain no-repeat;
  }
`;

const CardIcon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: var(--r-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto var(--sp-5) auto;
  border: 1.5px solid;
  transition: transform var(--dur) var(--ease), background var(--dur) var(--ease);

  ${(p) => {
    if (p.$muted) {
      return `
        background: var(--panel-bg);
        color: var(--text-muted);
        border-color: var(--input-border);
      `;
    }
    const tone = CARD_TONES[p.$tone] || CARD_TONES.account;
    return `
      background: ${tone.bg};
      color: ${tone.fg};
      border-color: ${tone.border};

      [data-theme='dark'] & {
        background: ${tone.bgDark};
        color: ${tone.fgDark};
        border-color: ${tone.borderDark};
      }
    `;
  }}

  ${ProfileCard}:hover & {
    transform: scale(1.1);
  }
`;

const CardTitle = styled.h3`
  margin: 0 0 var(--sp-2) 0;
  font-size: var(--fs-lg);
  font-weight: 700;
  color: var(--text);
  text-align: center;
`;

// Funkcja premium poza planem firmy (F.2): karta widoczna, z plakietką i „Chcę Premium”.
// Bez wyszarzenia całej karty (DisabledCard), bo przycisk w środku ma być czynny.
const PremiumCard = styled.div`
  background: var(--panel-bg);
  border: 1px dashed var(--input-border);
  border-radius: var(--r-lg);
  padding: var(--sp-8) var(--sp-6);
  position: relative;
  color: var(--text-muted);
  text-align: center;
`;

const CardPremiumSlot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sp-3);
  margin-top: var(--sp-3);
`;

const CardCornerBadge = styled.span`
  position: absolute;
  top: var(--sp-4);
  right: var(--sp-4);
`;

const CardDescription = styled.p`
  margin: 0;
  font-size: var(--fs-base);
  color: var(--text-muted);
  text-align: center;
  line-height: 1.5;
`;

export default function Profile() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [hasWidgetAccess, setHasWidgetAccess] = useState(false);
  // U.14: wariant plakietki planu w nagłówku ('superadmin' | 'premium' | 'basic').
  // Super-admin bypassuje gating (server.js#requireWidgetPremiumAccess), więc dostaje
  // własny wariant zamiast plakietki planu org — inaczej „Basic" kłóciłoby się z tym,
  // że widzi wszystkie funkcje premium.
  const [planVariant, setPlanVariant] = useState('basic');
  const { t } = useTranslation();

  useEffect(() => {
    // Widget access check (musi być przed early return)
    const isSuperAdmin = localStorage.getItem('isSuperAdmin') === '1';
    const isAdminLS = localStorage.getItem('isAdmin') === '1' || isSuperAdmin;
    const subscriptionPlan = localStorage.getItem('subscriptionPlan') || 'basic';
    setHasWidgetAccess(isSuperAdmin || (isAdminLS && subscriptionPlan === 'premium'));
    setPlanVariant(isSuperAdmin ? 'superadmin' : (subscriptionPlan === 'premium' ? 'premium' : 'basic'));

    const ls = localStorage.getItem("isAdmin");
    if (ls != null) {
      setIsAdmin(ls === "1" || ls === "true");
      return;
    }
    const uid = localStorage.getItem("userId");
    if (!uid) return;
    fetch(`${API_BASE}/api/users/${uid}`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : null))
      .then((u) => {
        const admin = !!(u?.is_admin === 1 || u?.isadmin === true || u?.isAdmin === true);
        setIsAdmin(admin);
      })
      .catch(() => {});
  }, []);

  return (
    <PanelContainer>
      <Hero>
        <CommonTitle>{t('profile.title')}</CommonTitle>
        <CommonSubtitle>{t('profile.subtitle')}</CommonSubtitle>
        <div>
          <PlanBadge variant={planVariant} data-cy="plan-badge">
            {t(`profile.plan.${planVariant}`)}
          </PlanBadge>
        </div>
      </Hero>

      {/* Grupa 1: Konto — ustawienia osobiste i (dla adminów) zespół. */}
      <Group data-tour="profile-account">
        <SectionTitle>{t('profile.group.account')}</SectionTitle>
        <Grid>
          <ProfileCard to="/your-data">
            <CardIcon $tone="account">
              <UserIcon />
            </CardIcon>
            <CardTitle>{t('profile.yourData')}</CardTitle>
            <CardDescription>{t('profile.description.yourData')}</CardDescription>
          </ProfileCard>

          <ProfileCard to="/security">
            <CardIcon $tone="account">
              <ShieldIcon />
            </CardIcon>
            <CardTitle>{t('profile.security')}</CardTitle>
            <CardDescription>{t('profile.description.security')}</CardDescription>
          </ProfileCard>

          <ProfileCard to="/preferences">
            <CardIcon $tone="account">
              <SettingsIcon />
            </CardIcon>
            <CardTitle>{t('profile.preferences')}</CardTitle>
            <CardDescription>{t('profile.description.preferences')}</CardDescription>
          </ProfileCard>

          {isAdmin ? (
            <ProfileCard to="/users">
              <CardIcon $tone="account">
                <UsersIcon />
              </CardIcon>
              <CardTitle>{t('profile.users')}</CardTitle>
              <CardDescription>{t('profile.description.users')}</CardDescription>
            </ProfileCard>
          ) : (
            <DisabledCard>
              <CardIcon $muted>
                <UsersIcon />
              </CardIcon>
              <CardTitle>{t('profile.users')}</CardTitle>
              <CardDescription>{t('users.adminOnly')}</CardDescription>
            </DisabledCard>
          )}
        </Grid>
      </Group>

      {/* Grupa 2: Firma i dokumenty — tylko admin. */}
      {isAdmin && (
        <Group data-tour="profile-company">
          <SectionTitle>{t('profile.group.company')}</SectionTitle>
          <Grid>
            <ProfileCard to="/contract-settings">
              <CardIcon $tone="company">
                <BuildingIcon />
              </CardIcon>
              <CardTitle>{t('profile.contractSettings')}</CardTitle>
              <CardDescription>{t('profile.description.contractSettings')}</CardDescription>
            </ProfileCard>

            <ProfileCard to="/ksef-settings">
              <CardIcon $tone="company">
                <ContractIcon />
              </CardIcon>
              <CardTitle>{t('profile.ksef')}</CardTitle>
              <CardDescription>{t('profile.description.ksef')}</CardDescription>
            </ProfileCard>
          </Grid>
        </Group>
      )}

      {/* Grupa 3: Sprzedaż — tylko admin. */}
      {isAdmin && (
        <Group>
          <SectionTitle>{t('profile.group.sales')}</SectionTitle>
          <Grid>
            <ProfileCard to="/price-rules">
              <CardIcon $tone="sales">
                <PriceTagIcon />
              </CardIcon>
              <CardTitle>{t('profile.priceRules')}</CardTitle>
              <CardDescription>{t('profile.description.priceRules')}</CardDescription>
            </ProfileCard>

            <ProfileCard to="/equipment-bundles">
              <CardIcon $tone="sales">
                <BundleIcon />
              </CardIcon>
              <CardTitle>{t('profile.equipmentBundles')}</CardTitle>
              <CardDescription>{t('profile.description.equipmentBundles')}</CardDescription>
            </ProfileCard>

            <ProfileCard to="/rental-rules" data-cy="profile-rental-rules">
              <CardIcon $tone="sales">
                <RulesIcon />
              </CardIcon>
              <CardTitle>{t('profile.rentalRules')}</CardTitle>
              <CardDescription>{t('profile.description.rentalRules')}</CardDescription>
            </ProfileCard>
          </Grid>
        </Group>
      )}

      {/* Grupa 4: Integracje — tylko admin. Widget dostaje własny gating premium
          (U.14): admin premium/super-admin widzi aktywną kartę do /widget-media,
          admin basic widzi tę samą kartę zablokowaną zamiast żeby zniknęła bez śladu. */}
      {isAdmin && (
        <Group>
          <SectionTitle>{t('profile.group.integrations')}</SectionTitle>
          <Grid>
            <ProfileCard to="/email-settings">
              {/* F.7/F.2: strona działa na każdym planie (usunięcie zapisanej konfiguracji), ale własny
                  serwer poczty jest w Premium. */}
              {planVariant === 'basic' && <CardCornerBadge><PremiumBadge /></CardCornerBadge>}
              <CardIcon $tone="integrations">
                <MailIcon />
              </CardIcon>
              <CardTitle>{t('profile.emailSettings')}</CardTitle>
              <CardDescription>{t('profile.description.emailSettings')}</CardDescription>
            </ProfileCard>

            <ProfileCard to="/import">
              <CardIcon $tone="integrations">
                <ImportIcon />
              </CardIcon>
              <CardTitle>{t('profile.import')}</CardTitle>
              <CardDescription>{t('profile.description.import')}</CardDescription>
            </ProfileCard>

            {/* F.12: eksport działa na każdym planie i w przerwie konta (dane należą do firmy). */}
            <ProfileCard to="/company-export" data-cy="profile-company-export">
              <CardIcon $tone="integrations">
                <ExportIcon />
              </CardIcon>
              <CardTitle>{t('profile.companyExport')}</CardTitle>
              <CardDescription>{t('profile.description.companyExport')}</CardDescription>
            </ProfileCard>

            {hasWidgetAccess ? (
              <ProfileCard to="/widget-media">
                <CardIcon $tone="integrations">
                  <WidgetIcon />
                </CardIcon>
                <CardTitle>{t('profile.widget')}</CardTitle>
                <CardDescription>{t('profile.description.widget')}</CardDescription>
              </ProfileCard>
            ) : (
              <PremiumCard data-cy="widget-locked">
                <CardIcon $muted>
                  <WidgetIcon />
                </CardIcon>
                <CardTitle>{t('profile.widget')}</CardTitle>
                <CardDescription>{t('profile.widget.premiumOnly')}</CardDescription>
                <CardPremiumSlot>
                  <PremiumBadge />
                  <ChcePremiumButton feature="widget" />
                </CardPremiumSlot>
              </PremiumCard>
            )}
          </Grid>
        </Group>
      )}
    </PanelContainer>
  );
}
